import { MediaType } from "constants/enums";
import { onDownloadImage } from "helpers";
import { useMemo, useRef } from "react";
import { Lightbox, Slide } from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";

import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

import { LightBoxGalleryProps } from "./LightBoxGallery.types";

const LightBoxGallery = ({
  mediaList,
  openedImageIndex,
  setOpenedImageIndex
}: LightBoxGalleryProps) => {
  const zoomRef = useRef(null);

  const gallerySlides: Slide[] = useMemo(() => {
    return mediaList.map((mediaItem) =>
      mediaItem.mediaType === MediaType.IMAGE
        ? {
            src: mediaItem.url,
            title: mediaItem.fileName
          }
        : mediaItem.mediaType === MediaType.VIDEO
          ? {
              type: "video",
              sources: [{ src: mediaItem.url, type: "video/mp4" }],
              title: mediaItem.fileName
            }
          : {
              src: mediaItem.url,
              title: mediaItem.fileName
            }
    );
  }, [mediaList]);

  return (
    <Lightbox
      styles={{ container: { backgroundColor: "rgba(0, 0, 0, .7)" } }}
      open={openedImageIndex !== undefined}
      index={openedImageIndex}
      on={{
        view: ({ index: currentIndex }) => setOpenedImageIndex(currentIndex)
      }}
      slides={gallerySlides}
      close={() => setOpenedImageIndex(undefined)}
      plugins={[Zoom, Video, Download]}
      zoom={{ ref: zoomRef }}
      controller={{ closeOnBackdropClick: true }}
      download={{
        download: () => {
          if (openedImageIndex === undefined) return;
          onDownloadImage(mediaList[openedImageIndex]);
        }
      }}
    />
  );
};

export default LightBoxGallery;
